/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Account {
  id?: number;
  commissionRate?: number;
  status?: Account.StatusEnum;
  allowNegativeEquityWithdraw?: boolean;
  name?: string;
  accountType?: Account.AccountTypeEnum;
  stableCoinCommissionRate?: number;
  referralAgentId?: number;
  allowRfq?: boolean;
  qtyLevelsTier?: Account.QtyLevelsTierEnum;
  businessEntity?: Account.BusinessEntityEnum;
  allowInterceptors?: boolean;
  routePresetId?: number;
  maxIocOrderLifeTimeNs?: number;
  disableWithdrawBalanceCheck?: boolean;
  ssoOnly?: boolean;
  parentAccountId?: number;
  subAccountType?: Account.SubAccountTypeEnum;
}
export namespace Account {
  export const StatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Paused: 'PAUSED',
    Locked: 'LOCKED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const AccountTypeEnum = {
    Company: 'COMPANY',
    Individual: 'INDIVIDUAL',
    HouseLp: 'HOUSE_LP',
    ExternalLp: 'EXTERNAL_LP',
    LiquidityReceiver: 'LIQUIDITY_RECEIVER',
    LiquidityStream: 'LIQUIDITY_STREAM',
  } as const;
  export type AccountTypeEnum = (typeof AccountTypeEnum)[keyof typeof AccountTypeEnum];
  export const QtyLevelsTierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type QtyLevelsTierEnum = (typeof QtyLevelsTierEnum)[keyof typeof QtyLevelsTierEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
  export const SubAccountTypeEnum = {
    Trading: 'TRADING',
    Strategy: 'STRATEGY',
  } as const;
  export type SubAccountTypeEnum = (typeof SubAccountTypeEnum)[keyof typeof SubAccountTypeEnum];
}
